import React from "react";
import { Typography } from "@mui/material";

const CopyrightText = ({
  variant = "body2",
  color = "text.secondary",
  prefix = "©",
  company = "Panasonic Life Solutions India Pvt. Ltd. All rights reserved",
  sx,
}) => {
  const year = new Date().getFullYear();

  return (
    <Typography variant={variant} color={color} sx={sx}>
      <small>
        {prefix} {year} - {company}
      </small>
    </Typography>
  );
};

export default CopyrightText;
